import { createTheme } from '@mui/material'

export const themeInternational = createTheme({
  palette: {
    primary: {
      light: '#5C688E',
      main: '#303E60',
      dark: '#021836'
    },
    secondary: {
      light: '#8E57AB',
      main: '#5F2B7B',
      dark: '#32004E'
    }
  }
})

export const themeUs = createTheme({
  palette: {
    primary: {
      light: '#cb9393',
      main: '#A03245',
      dark: '#8c1a2d'
    },
    secondary: {
      light: '#666FBF',
      main: '#303F9F',
      dark: '#1C2A6F'
    }
  }
})
